import { W8BenForm } from 'modules/onboarding/common/components';

import { useOwnerW8BenForm } from '../hooks';
import { PageComponentProps } from '../types';

export const OwnerW8BenFormStep = ({ canGoBack }: PageComponentProps) => {
  const {
    initialValues,
    submitLoading,
    files,
    submitDisabled,
    onAddFiles,
    onRemoveFile,
    onSubmit,
    goToBack,
  } = useOwnerW8BenForm();

  return (
    <W8BenForm
      canGoBack={canGoBack}
      files={files}
      formType="W8BENForm"
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
